<template>
    <v-container class="pa-5" fluid>
        <page-title>Produkcja w toku</page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Generuj raport"
                    :disabled="actionLoading.generateReportLoading"
                    @click="generateOrdersInProgressReport"
                >
                    <v-icon
                        v-if="!actionLoading.generateReportLoading"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="ordersInProgress"
                        :loading="actionLoading.getOrdersInProgress"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        @pagination="updatePagination"
                    >
                        <template #item.orderFullNumberCfPrint="{item}">
                            {{ item.orderFullNumberCfPrint }}
                        </template>
                        <template #item.orderWarehouseReportDate="{item}">
                            {{ item.orderWarehouseReportDate }}
                        </template>
                        <template #item.orderAmount="{item}">
                            {{ item.orderAmount }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'

import { errorHandler } from '@/utils/errorHandler'

import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'

export default {
    name: 'OrdersInProgress',
    components: {
        PageTitle
    },
    mixins: [
        filters,
        pagination,
        dateFormatter,
        tooltipDelay,
        dataTableClassSetter
    ],
    data() {
        return {
            headers: [
                {
                    text: 'Numer zamówienia',
                    value: 'orderFullNumberCfPrint',
                    sortable: false
                },
                {
                    text: 'Data pobrania papieru',
                    value: 'orderWarehouseReportDate',
                    sortable: false
                },
                {
                    text: 'Ilość',
                    value: 'orderAmount',
                    sortable: false
                },
            ],
            orders: [],
            actionLoading: {
                getOrdersInProgress: false,
                generateReportLoading: false
            },
            user: {},
        }
    },
    computed: {
        ordersInProgress() {
            return this.$store.state.reportsAndAnalysis.orders.placedOrders.ordersInProgress
        },
        userId() {
            return this.$store.state.user.userId
        },
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.getOrdersInProgress()
        this.$store.dispatch('administration/getUser', this.userId)
            .then(response => {
                this.user = response.data
            })
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        getOrdersInProgress() {
            this.actionLoading.getOrdersInProgress = true

            this.$store.dispatch('reportsAndAnalysis/orders/getOrdersInProgress', {
                paginate: this.paginate(),
                query: ''
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.getOrdersInProgress = false
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && !this.savedPagination.pagination) {
                this.getOrdersInProgress()
            }
            this.clearPaginationPending()
        },
        generateOrdersInProgressReport() {
            this.actionLoading.generateReportLoading = true
            this.$store.dispatch('reportsAndAnalysis/orders/generateOrdersInProgressReport', {
                userEmail: this.user.email
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generateReportLoading = false
                })
        },
        close() {
            this.$router.push({ name: 'reportingAndAnalysisOrdersOrders' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>